export const MONITORING_SERVICE_ENDPOINT = window.env.VUE_APP_MONITORING_SERVICE_URL;

/***** Resource paths *****/
export const MONITORING_VARIABLES_RESOURCE_PATH = '/log';
export const MONITORING_SESSION_SUGGESTIONS_RESOURCE_PATH = '/session-suggestions';

